import('./bootstrap').catch(error => {
  console.error('Host bootstrap failed', error)
})
